module.exports = __webpack_public_path__ + "img/sales.034cfeb5.svg";